<form class="gCaptcha" [formGroup]="forms">
    <re-captcha id="recaptchaReactive" name="recaptchaReactive" siteKey="{{ GoogleRE_CAPTCHA_KEY }}" (resolved)="resolved($event)"></re-captcha>
</form>